import React from 'react'
import cx from 'classnames'
import omit from 'lodash/omit'

import { Card } from '../Card'
import cm from '../Card.module.css'
import { SafeButtonOwnProps } from '../constants'
import { useFastClick } from '../hooks/useFastClick'
import { CardBlockElements, CardButtonProps } from '../interfaces'

export const CardButtonBase = <T extends CardBlockElements = 'div'>({
  buttonType,
  onClick,
  children,
  className,
  ariaLabel,
  disabled,
  buttonClassName,
  ...rest
}: CardButtonProps<T>) => {
  const ref = React.useRef<HTMLButtonElement | null>(null)
  const { mouseDown, mouseUp } = useFastClick(ref)
  const button = !disabled ? (
    <button
      ref={ref}
      aria-label={ariaLabel}
      type={buttonType ?? 'button'}
      onClick={onClick}
      className={cx(cm.cardTrigger, buttonClassName)}
    />
  ) : null

  return (
    <Card
      {...omit(rest, SafeButtonOwnProps)}
      onMouseDown={mouseDown}
      onMouseUp={mouseUp}
      disabled={disabled}
      className={cx({ [cm.interactive]: !disabled }, className)}
    >
      {children}
      {button}
    </Card>
  )
}
